import React, { useEffect, useState } from 'react'
import { Box, Slider, Typography } from '@mui/material'
import { useSelector } from 'react-redux'

const TableSlider = (props) => {
    const [answerArray, setAnswerArray] = useState([])

    const [responseIndex, setResponseIndex] = useState(0)
    const [responseText, setResponseText] = useState("")
    const { viewInstance, settings } = useSelector(state => state.viewinstance)


    useEffect(() => {
        if(!answerArray.length){
            let array = [...props.question.Answers].sort((a, b) => a.AnswerSequenceInQuestion - b.AnswerSequenceInQuestion)
            array.unshift({AnswerId:"-1", AnswerStandardContent:viewInstance?.SurveyPage?.OtherLabels?.PleaseAnswer || "Please Answer"})
            setAnswerArray(array)
        }
        if(!responseText && answerArray.length){
            if(props.question.Responses[0].Response){
            for(let i=0; i<answerArray.length; i++){
                if(answerArray[i].AnswerId == props.question.Responses[0].Response){
                    setResponseIndex(i)
                    setResponseText(answerArray[i].AnswerStandardContent)
                }
            }
            }
            else {
                setResponseIndex(0)
                setResponseText(answerArray[0].AnswerStandardContent)
            }
        }
        
    }, [answerArray])

    const handleChange = (ev, value) => {
        props.saveAnswer(answerArray[value].AnswerId, props.QuestionId)
    }

    const handleSliding = (ev, value) => {
         setResponseIndex(value)
         setResponseText(answerArray[value].AnswerStandardContent)
     }

    if(props){
        return (
            <Box flex>
                <Typography variant="body2" role="label" aria-label={responseText} id={props.question.QuestionId + "-slider-value"}>{responseText}</Typography>
                <Slider
                  value={responseIndex}
                  marks
                  step={1}
                  min={0}
                  max={props.question.Answers.length} 
                  onChange={handleSliding}
                  onChangeCommitted={handleChange}
                  aria-label={props.question.QuestionStandardContent + " slider"}
                  aria-labelledby={props.question.QuestionId + "-slider-value"}/> 
            </Box>)}
}

export default TableSlider;